<template>
  <content-with-sidebar data-v-sticky-container>
    <!-- content -->
    <div class="blog-detail-wrapper">
      <b-container>
        <b-card
          :img-src="news.image_url"
          :img-alt="news.title"
          img-top
          class="mb-2"
        >
          <b-card-text>
            <h4>{{ news.title }}</h4>
          </b-card-text>
            <b-card-text>
            <div class="mb-1">
              <small class="text-muted mr-2">
                  <span>by </span>
                  <strong>{{ news.author }}</strong>
                </small>
                <small class="text-muted">{{
                  $moment(news.published_at).format('DD-MMM-YYYY')
                }}</small>
              </div>
            </b-card-text>
            
            <b-card-text v-html="news.content" />
          <div class="d-flex justify-content-end">
            <b-button :to="{ name: 'home' }" variant="primary">Back</b-button>
          </div>
        </b-card>
      </b-container>
      <!--/ blogs -->
    </div>
    <!--/ content -->

    <!-- sidebar -->
    <div slot="sidebar" class="blog-sidebar" v-sticky="options">
      <!-- categories -->
      <div class="blog-categories" :class="{ topstick: !showNavbar }">
        <b-button
          v-if="!showNavbar"
          variant="primary"
          class="d-lg-none d-flex align-items-center mb-1"
          @click="isCategoriesVisible = !isCategoriesVisible"
          aria-controls="collapse-categories"
        >
          <span>Latest News</span>
          <feather-icon 
            :icon="isCategoriesVisible ? 'ChevronUpIcon' : 'ChevronDownIcon'" 
            size="16"
            class="ml-auto"
          />
        </b-button>

        <b-collapse 
          id="collapse-categories" 
          v-model="isCategoriesVisible"
          class="d-lg-block links-container"
        >
          <div class="d-none d-lg-flex justify-content-start align-items-center mb-75">
            <h4>Latest News</h4>
          </div>
          <div v-for="news in otherNews" :key="news.id" class="d-flex justify-content-start align-items-center mb-75">
            <b-link>
              <b-avatar rounded size="32" variant="light-danger" class="mr-75">
                <feather-icon icon="MessageSquareIcon" size="16" />
              </b-avatar>
            </b-link>
            <b-link @click="goOther(news.slug)">
              <div class="blog-category-title text-body">
                {{news.title}}
              </div>
            </b-link>
          </div>
        </b-collapse>
      </div>
      <!--/ categories -->
    </div>
  </content-with-sidebar>
</template>

<script>
import { BAvatar,BLink,BCardText,BCard, BContainer, BRow, BCol, BButton, BCollapse } from 'bootstrap-vue'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'

export default {
  components: {
    BAvatar,
    ContentWithSidebar,
    BCardText,
    BCard,
    BLink,
    BContainer,
    BRow,
    BCol,
    BButton,
    BCollapse,
  },

  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0,
      otherNews: {},
      news: {},
      options: {
        topSpacing: 0,
        bottomSpacing: 0,
        containerSelector: '[data-v-sticky-container]',
        innerWrapperSelector: '[data-v-sticky-inner]',
        resizeSensor: true, // [1] read above
        stickyClass: 'is-affixed',
        minWidth: 0,
      },
      isCategoriesVisible: false,
    }
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  mounted() {
    this.fetchNews()
    this.fetchOther()
    window.addEventListener('scroll', this.onScroll)
  },

  methods: {
    goOther(id) {
      window.location.href = 'https://productcatalog.telkom.co.id/news-detail/'+id
      // this.$router.push({name: 'news-detail', params: { slug: id }} )
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }

      this.showNavbar = currentScrollPosition < 120
      this.lastScrollPosition = currentScrollPosition
    },
    fetchNews() {
      this.$http
        .get(`/browse-news/${this.$route.params.slug}`)
        .then(({ data }) => {
          this.news = data.data
        })
        .catch(err => {
          this.$router.push({ name: 'home' })
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
    fetchOther() {
      this.$http
        .get(`/other-news/${this.$route.params.slug}`)
        .then(({ data }) => {
          this.otherNews = data.data
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
  },
}
</script>

<style scoped>
.topstick {
  margin-top: 3vh;
  width: fit-content;
}

.links-container {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

@media (min-width: 992px) {
  .links-container {
    background-color: unset;
    border-radius: unset;
    box-shadow: unset;
    padding: unset;
  }
}

.card-img, .card-img-top, .card-img-bottom {
  aspect-ratio: 16/9;
  max-height: calc(104.35vh/1.7);
  object-fit: cover;
  object-position: center;
}
</style>